import { isoDateTime, onlyStrings, stripTags, truncate } from './text';
import type { JsonLdNode } from './types';

export interface VideoJsonLdSource {
  name?: string | null;
  description?: string | null;
  thumbnailUrls?: ReadonlyArray<string | null | undefined> | null;
  contentUrl?: string | null;
  embedUrl?: string | null;
  uploadDate?: string | number | null;
  duration?: string | null;
}

export const buildVideoObject = (
  source: VideoJsonLdSource | null | undefined
): JsonLdNode | null => {
  if (!source) {
    return null;
  }
  const name = source.name?.trim();
  const thumbnailUrl = onlyStrings(source.thumbnailUrls);
  const uploadDate = isoDateTime(source.uploadDate);
  if (!name || thumbnailUrl.length === 0 || !uploadDate) {
    return null;
  }
  const description = stripTags(source.description);
  return {
    '@type': 'VideoObject',
    name,
    description: description ? truncate(description, 500) : undefined,
    thumbnailUrl,
    contentUrl: source.contentUrl ?? undefined,
    embedUrl: source.embedUrl ?? undefined,
    uploadDate,
    duration: source.duration ?? undefined
  };
};
